export interface ISystemMessage {
    id: string;
    createDate: string;
    title: string;
    body: string;
    type: MessageTypeEnum
}

export enum MessageTypeEnum {
  Regular,
  DeploymentSuccess
}